
<div class="container">
    <div class="header-wrapper">
      <div class="header">
          <div class="filters top-filters">
              <!-- Search -->
              <div class="filter-search" [class.filter-search--active]="searchString">
                  <svg class="filter-search__icon" viewBox="0 0 14 14" aria-hidden="true">
                      <path d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"></path>
                  </svg>
                  <input #searchInput class="filter-search__input" type="text" autocomplete="off"
                      placeholder="Search titles" aria-label="Search shows"
                      (input)="onSearch(searchInput.value)" (keydown.escape)="clearSearch(searchInput)">
                  <button *ngIf="searchString" type="button" class="filter-search__clear" aria-label="Clear search"
                      (click)="clearSearch(searchInput)">
                      <svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"></path></svg>
                  </button>
              </div>

              <!-- Partner group -->
              <app-select-search class="partner-group-filter" placeholder="Partner Group" [(ngModel)]="selectedPartnerGroupId">
                  <app-select-item [value]="null">All partner groups</app-select-item>
                  <app-select-item *ngFor="let group of partnerGroups; trackBy: trackById" [value]="group.id">{{ group.name }}</app-select-item>
              </app-select-search>

              <!-- Result count -->
              <span *ngIf="dataSource && !showsError" class="filter-count" [class.filter-count--stale]="loadingShows" aria-live="polite">
                  <span class="filter-count__number">{{ shownCount | number }}</span>
                  {{ shownCount === 1 ? 'show' : 'shows' }}<ng-container *ngIf="shownPartnerGroupName"> in <b class="filter-count__group">{{ shownPartnerGroupName }}</b></ng-container>
              </span>
          </div>
          <div class="actions">
              <!-- <button class="button" (click)="createNewShow()">Create Show</button> -->
              <button class="button" (click)="openCreateNewShowModal()">Create Show</button>
              <!-- <button class="button" (click)="openCreateNewSeasonModal()">Create Season</button> -->
              <!-- <button class="button" (click)="createNewEpisode()">Create Episode</button> -->
              <!-- <button class="button">Add Selected To Group</button> -->
          </div>
      </div>
  </div>
</div>

<div class="shows-progress" [class.shows-progress--active]="loadingShows" aria-hidden="true"></div>

<mat-table [dataSource]="dataSource" matSort class="track-list" multiTemplateDataRows
    [class.track-list--loading]="loadingShows" [attr.aria-busy]="loadingShows">

    <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Show Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.title }}
          <span *ngIf="row.matched_via_episode" class="match-tag" matTooltipClass="tooltip-white"
            matTooltip="Listed because one of its episodes is assigned to this partner group">Via episode</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="seasons">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Seasons</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.seasons.length }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="notes">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Notes</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.description }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="partnerGroup">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Partner Group</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <b>
            {{ getPartnerGroupNameById(row.partnerGroup_id) }}
          </b>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button (click)="openAlternateTitleModal(row)" style="margin-left:35px;" type="button"
          matTooltip="Alternate Titles" matTooltipClass="tooltip-white" class="action-button">
          <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-292.000000, -20.000000)">
                <g transform="translate(0.000000, -4.000000)">
                  <g transform="translate(292.000000, 24.000000)" class="inner-stroke">
                    <circle cx="8" cy="8" r="7.5"></circle>
                    <circle fill-rule="nonzero" cx="8" cy="4.75" r="1"></circle>
                    <line x1="8" y1="11" x2="8" y2="8" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"></line>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
          <button class="button" matTooltip="Add Season" matTooltipClass="tooltip-white" (click)="openCreateNewSeasonModal(row)">
            Add Season
          </button>
          <button class="button" matTooltip="Assign Partner Group" matTooltipClass="tooltip-white" (click)="openAssignToPartnerGroupModal(row)">
            Assign Partner Group
          </button>
          <app-drop-down-arrow></app-drop-down-arrow>
        </mat-cell>
      </ng-container>
      
      <!-- <ng-container matColumnDef="dropdown-arrow">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
        </mat-cell>
      </ng-container> -->

      
      <!-- <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button type="button" (click)="$event.preventDefault();$event.stopPropagation();expandShow(row)" class="versions-toggle" class="expand-button">
            <svg width="10px" height="5px" viewBox="0 0 10 5" class="carrot"
              [ngClass]="{ flip: showIsExpanded(row) }">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
                stroke-linejoin="round">
                <g transform="translate(-1392.000000, -396.000000)" class="inner-stroke" stroke-width="0.95">
                  <g transform="translate(392.000000, 351.000000)">
                    <g transform="translate(920.550000, 36.100000)">
                      <polyline points="80.75 9.5 84.55 13.3 88.35 9.5"></polyline>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </mat-cell>
      </ng-container> -->
    
      <ng-container matColumnDef="expandedShowDetail">
        <mat-cell *matCellDef="let row" class="expanded-cell">
          <div class="season" *ngFor="let season of row.seasons; trackBy: trackById">
            <!-- Season -->
            <div class="version-row season-row">
              <span class="season-title">Season {{ season.season_number }}</span>
              <button *ngIf="canDelete" type="button" matTooltip="Delete Season" matTooltipClass="tooltip-white"
                class="action-button" (click)="deleteSeason(row, season)">
                <!-- trash can -->
                <svg width="14px" height="16px" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                  <g class="inner-stroke" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                    transform="translate(1.000000, 1.000000)">
                    <polyline points="0 2.8 1.33333333 2.8 12 2.8"></polyline>
                    <path d="M10.6666667,2.8 L10.6666667,12.6 C10.6666667,13.3731986 10.069713,14 9.33333333,14 L2.66666667,14 C1.930287,14 1.33333333,13.3731986 1.33333333,12.6 L1.33333333,2.8 M3.33333333,2.8 L3.33333333,1.4 C3.33333333,0.62680135 3.930287,0 4.66666667,0 L7.33333333,0 C8.069713,0 8.66666667,0.62680135 8.66666667,1.4 L8.66666667,2.8"></path>
                    <line x1="4.66666667" y1="6.3" x2="4.66666667" y2="10.5"></line>
                    <line x1="7.33333333" y1="6.3" x2="7.33333333" y2="10.5"></line>
                  </g>
                </svg>
              </button>
              <button type="button" class="action-button" (click)="expandSeason(season)"
                [attr.aria-label]="seasonIsExpanded(season) ? 'Hide episodes' : 'Show episodes'"
                [attr.aria-expanded]="seasonIsExpanded(season)">
                <!-- chevron: points down when collapsed, flips up when expanded -->
                <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                  class="expand-chevron" [class.expanded]="seasonIsExpanded(season)">
                  <polyline class="inner-stroke" points="4 6 8 10 12 6" fill="none" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round"></polyline>
                </svg>
              </button>
            </div>
            <!-- Episodes -->
            <div class="episodes" [@seasonDetailExpand]="seasonIsExpanded(season) ? 'expanded' : 'collapsed'">
              <div class="version-row episode-row">
                <button type="button" matTooltip="Add Episode" matTooltipClass="tooltip-white"
                  class="action-button add-episode-button" (click)="openEpisodeInfoModal(season)">
                  <!-- plus in a circle -->
                  <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <g class="inner-stroke" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="8" cy="8" r="7"></circle>
                      <line x1="8" y1="4.5" x2="8" y2="11.5"></line>
                      <line x1="4.5" y1="8" x2="11.5" y2="8"></line>
                    </g>
                  </svg>
                </button>
                <span *ngIf="!season.episodes.length" class="no-episodes">No episodes</span>
              </div>
              <div class="version-row episode-row" *ngFor="let episode of season.episodes; trackBy: trackById">
                <span class="episode-title">Episode {{ episode.episode_number }}: {{ episode.title }}</span>
                <span class="episode-partner-group" [class.episode-partner-group--inherited]="!episodeHasOwnPartnerGroup(episode)"
                  [matTooltip]="episodePartnerGroupTooltip(row, episode)" matTooltipClass="tooltip-white">{{ getPartnerGroupNameById(episodePartnerGroupId(row, episode)) }}</span>
                <button type="button" matTooltip="Edit Episode" matTooltipClass="tooltip-white" class="action-button"
                  (click)="openEpisodeInfoModal(season, episode)">
                  <!-- pencil on a page -->
                  <svg width="15px" height="15px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <g class="inner-stroke" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                      transform="translate(1.000000, 1.000000)">
                      <path d="M14.4,10.128 L14.4,14.4 C14.4,15.2836556 13.6836556,16 12.8,16 L1.6,16 C0.7163444,16 0,15.2836556 0,14.4 L0,3.2 C0,2.3163444 0.7163444,1.6 1.6,1.6 L5.872,1.6"></path>
                      <polygon points="12.8 0 16 3.2 8 11.2 4.8 11.2 4.8 8"></polygon>
                    </g>
                  </svg>
                </button>
                <button *ngIf="canDelete" type="button" matTooltip="Delete Episode" matTooltipClass="tooltip-white"
                  class="action-button" (click)="deleteEpisode(season, episode)">
                  <!-- trash can -->
                  <svg width="14px" height="16px" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                    <g class="inner-stroke" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                      transform="translate(1.000000, 1.000000)">
                      <polyline points="0 2.8 1.33333333 2.8 12 2.8"></polyline>
                      <path d="M10.6666667,2.8 L10.6666667,12.6 C10.6666667,13.3731986 10.069713,14 9.33333333,14 L2.66666667,14 C1.930287,14 1.33333333,13.3731986 1.33333333,12.6 L1.33333333,2.8 M3.33333333,2.8 L3.33333333,1.4 C3.33333333,0.62680135 3.930287,0 4.66666667,0 L7.33333333,0 C8.069713,0 8.66666667,0.62680135 8.66666667,1.4 L8.66666667,2.8"></path>
                      <line x1="4.66666667" y1="6.3" x2="4.66666667" y2="10.5"></line>
                      <line x1="7.33333333" y1="6.3" x2="7.33333333" y2="10.5"></line>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </mat-cell>
      </ng-container>  
  
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="main-row"
      [ngClass]="{ expanded: showIsExpanded(row) }" (click)="expandShow(row)"></mat-row>
      <mat-row *matRowDef="let row; columns: ['expandedShowDetail']" class="detail-row"
      [@showDetailExpand]="showIsExpanded(row) ? 'expanded' : 'collapsed'"></mat-row>

      

        
</mat-table>

<!-- Empty -->
<div *ngIf="showEmptyState" class="shows-state">
    <svg class="shows-state__icon" viewBox="0 0 64 64" aria-hidden="true">
        <circle class="shows-state__ring" cx="32" cy="32" r="30"></circle>
        <rect x="16" y="20" width="32" height="21" rx="3"></rect>
        <path d="M27 46h10M32 41v5M26 14l6 6 6-6"></path>
    </svg>
    <p class="shows-state__title">{{ emptyStateTitle }}</p>
    <p class="shows-state__hint" *ngIf="searchString">Nothing matches &ldquo;{{ searchString }}&rdquo;<ng-container *ngIf="selectedPartnerGroupName"> in {{ selectedPartnerGroupName }}</ng-container>.</p>
    <p class="shows-state__hint" *ngIf="!searchString && selectedPartnerGroupName">No show or episode is assigned to {{ selectedPartnerGroupName }} yet.</p>
    <div class="shows-state__actions">
        <button *ngIf="searchString" type="button" class="button" (click)="clearSearch(searchInput)">Clear search</button>
        <button *ngIf="selectedPartnerGroupName" type="button" class="button" (click)="selectedPartnerGroupId = null">Show all partner groups</button>
    </div>
</div>

<!-- Error -->
<div *ngIf="showsError" class="shows-state shows-state--error" role="alert">
    <p class="shows-state__title">The shows could not be loaded</p>
    <p class="shows-state__hint">Check your connection, then try again.</p>
    <div class="shows-state__actions">
        <button type="button" class="button" (click)="loadShows()">Try again</button>
    </div>
</div>
